export default { // methods
    updateAccess(state, data) {
        state.access = data;
    },
    updateRol(state, data) {
        state.Rol = data;
    },
    updateIdRol(state, data) {
        state.IdRol = data;
    },
    updateNameCustomer(state, data) {
        state.NameCustomer = data;
    },
    updateUser(state, data) {
        state.user = data;
    },
    updateLoader(state, data) {
        state.loader = data;
    }
}